import { TeacherManagementTable } from './TeacherManagementTable';
export default TeacherManagementTable;
